<template>
  <div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />

    <vs-table
      :sst="true"
      max-items="20"
      :data="usersData"
      noDataText="No se encontraron datos"
    >

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">


          <!-- ADD NEW -->
          <div v-if="$acl.check('owner')" class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Añadir Usuario</span>
          </div>

        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Nombre</vs-th>
        <vs-th sort-key="mail">Correo</vs-th>
        <vs-th sort-key="user_rol">Rol</vs-th>
        <vs-th sort-key="register_date">Fecha registro</vs-th>
        <vs-th>Acciones</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td class="name-w">
              <p class="product-name font-medium truncate">{{ tr.name }}</p>
            </vs-td>

            <vs-td class="mail-w">
              <p class="product-category">{{ tr.email }}</p>
            </vs-td>

            <vs-td>
              <vs-chip color="primary" class="product-order-status">{{ tr.role }}</vs-chip>
            </vs-td>

            <vs-td>
              <p class="product-price">{{ tr.created_at }}</p>
            </vs-td>

            <vs-td >
              <vx-tooltip v-if="$acl.check('owner')" text="Ascender a propietario" position="top" class="d-inline-block mr-3">
                <feather-icon v-if="tr.role === 'Invitado'" icon="ChevronsUpIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click="promoteRole(tr.id)" />
              </vx-tooltip>

              <vx-tooltip v-if="$acl.check('owner')" text="Eliminar" position="top" class="d-inline-block">
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click="deleteUser(tr.id)" />
              </vx-tooltip>
            </vs-td>

          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import DataViewSidebar from './DataViewSidebar.vue'
import moduleDataList from '@/store/data-list/moduleDataList.js'

export default {
  components: {
    DataViewSidebar
  },
  data () {
    return {
      currentPage: 1,
      searching: '',
      selected: [],
      itemsPerPage: 15,
      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  computed: {
    usersData() {
      return this.$store.state.users.users.data;
    },
    getTotalPages() {
      return this.$store.state.users.users.pagination.total
    },
    selectedCompany() {
      return this.$store.state.account.user.me.selected_company.id;
    }
  },
  methods: {
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    deleteUser (id) {
      let instance = this;
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: `Confirmar`,
        acceptText: "Sí",
        cancelText: "No",
        text: '¿Estás seguro de eliminar al usuario?',
        accept:function () {
          instance.$store.dispatch("users/delete", {user_id: id, company_id: instance.selectedCompany});
        },
      })
    },
    promoteRole (id) {
      let instance = this;
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: `Confirmar`,
        acceptText: "Sí",
        cancelText: "No",
        text: '¿Estás seguro de promover este usuario a propietario?',
        accept:function () {
          instance.$store.dispatch("users/promoteRole", {user_id: id, company_id: instance.selectedCompany, aclChangeRole: this.$acl.change});
        },
      })
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    }
  },
  created () {
    this.$store.dispatch('users/getAll', {company_id: this.selectedCompany, page: this.currentPage - 1}).catch(err => { console.error(err) })
  },
}
</script>

<style lang="scss">
#data-list-list-view {

  .name-w{
    width: 25%;
  }
  .mail-w{
    width: 25%;
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
        box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
        td{
          padding: 20px;
          &:first-child{
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }
          &:last-child{
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }
        td.td-check{
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
